var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevroneDown({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44275 1.2567C8.44275 1.4477 8.36975 1.6397 8.22375 1.7857L4.75375 5.2727C4.61275 5.4137 4.42175 5.4927 4.22175 5.4927C4.02275 5.4927 3.83175 5.4137 3.69075 5.2727L0.218751 1.7857C-0.0732494 1.4927 -0.0732494 1.0187 0.220751 0.725701C0.514751 0.433701 0.989751 0.434701 1.28175 0.727701L4.22175 3.6807L7.16175 0.727701C7.45375 0.434701 7.92775 0.433701 8.22175 0.725701C8.36975 0.871701 8.44275 1.0647 8.44275 1.2567Z"
  })));
}

export default SvgChevroneDown;